import React from "react";
import envelope from "../assets/icons/envelope.svg";
import telephone from "../assets/icons/telephone.svg";
import print from "../assets/icons/print.svg";
import instagram from "../assets/icons/bxl-instagram.svg";
import telegram from "../assets/icons/bxl-telegram.svg";
import vector from "../assets/icons/vector.svg";

const ContactUsPage = ({ exchangeData }) => {
  return (
    <div className="contact-us-container flex my-[5.12rem] mx-[14rem] gap-[5.69rem] max-[580px]:flex-col-reverse max-[580px]:mx-[4.25rem] max-[1500px]:mx-[1rem] max-[1500px]:gap-[1rem]">
      <div>
        <div className=" mb-[3rem] text-[#404040] text-right text-[3rem] font-[700] leading-none not-italic max-[580px]:text-[2rem]">
          تماس با ما{" "}
          <div className="my-[1.5rem] text-[#404040] text-right text-[3rem] font-[700] leading-none not-italic max-[580px]:text-[2rem]">
            از راه های زیر با ما در{" "}
            <span className="text-[#E7B555] text-[3rem] font-[700] leading-none not-italic max-[580px]:text-[2rem]">
              ارتباط
            </span>{" "}
            باشید.
          </div>
        </div>
        <div>
          <div className="flex justify-start items-center gap-[1rem] my-[1.5rem] ml-[1.5rem]">
            <img src={envelope} alt="envelope" />
            <a
              href={`mailto:${exchangeData?.email}`}
              className=" hover:underline"
            >
              {exchangeData?.email}
            </a>
          </div>

          <div className="flex justify-start items-center gap-[1rem] my-[1.5rem] ml-[1.5rem]">
            <img src={telephone} alt="phone" />
            <a
              href={`tel:${exchangeData?.phone}`}
              className=" hover:underline"
            >
              {exchangeData?.phone}
            </a>
          </div>

          <div className="flex justify-start items-center gap-[1rem] my-[1.5rem] ml-[1.5rem]">
            <img src={print} alt="fax" />
            <a
              href={`fax:${exchangeData?.fax}`}
              className=" hover:underline"
            >
              فکس: {exchangeData?.fax?.substring(4)}-
              {exchangeData?.fax?.substring(0, 3)}
            </a>
          </div>

          <div className="flex justify-start items-center gap-[1rem] my-[1.5rem] ml-[1.5rem]">
            <img src={instagram} alt="instagram" />
            <a
              href={`https://www.instagram.com/p/DaHxzN1DV1M/`}
              target="_blank"
              rel="noopener noreferrer"
              className=" hover:underline"
            >
              sarafiiex@
            </a>
          </div>

          <div className="flex justify-start items-center gap-[1rem] my-[1.5rem] ml-[1.5rem]">
            <img src={telegram} alt="telegram" />
            <a
              href={`https://t.me/${exchangeData?.telegram}`}
              target="_blank"
              rel="noopener noreferrer"
              className=" hover:underline"
            >
              {exchangeData?.telegram}@
            </a>
          </div>

          <div className="flex justify-start items-center gap-[1rem] my-[1.5rem] ml-[1.5rem]">
            <img src={vector} alt="address" />
            <a
              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                exchangeData?.address
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              className=" hover:underline"
            >
              {exchangeData?.address}
            </a>
          </div>
        </div>
      </div>
      <div>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3237.701332558102!2d51.39784667637056!3d35.75814502574418!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f8e06efef56fc9d%3A0x5d33ecc6081462e!2sIExchange!5e0!3m2!1sen!2sde!4v1734266209497!5m2!1sen!2sde"
          width="600"
          height="450"
          loading="lazy"
        ></iframe>
      </div>
    </div>
  );
};

export default ContactUsPage;
